import { ReactNode } from 'react';
import FullPage from '@/src/components/UI/FullPage';

export default function AboutFounder({ title, children }: { title: string; children: ReactNode }) {
  return (
    <FullPage headerRight={['share']} hasPadding={true} title={title} hasHeaderPlaceHolder>
      {children}
    </FullPage>
  );
}
